





































import { Component, Prop, Vue } from 'vue-property-decorator'

import SmsAuthTokenForm from '@spa/components/organisms/auth/SmsAuthTokenForm.vue'

@Component({
  components: {
    SmsAuthTokenForm,
  },
})
export default class InputSmsAuthToken extends Vue {
  @Prop({ required: true })
  readonly tel: string

  @Prop({ required: true })
  readonly step: number

  @Prop({ required: true })
  resendStatus: ResendStatus

  token: string = ''

  get resendLabel(): string {
    switch (this.resendStatus) {
      case 'standby':
        return '認証コードを再送する'
      case 'sending':
        return '送信中...'
      case 'complete':
        return '送信しました'
      default:
        return ''
    }
  }

  handleTokenUpdated(token: string) {
    this.token = token
  }

  submit() {
    this.$emit('submit-token', this.token)
  }

  resendRequested() {
    if (this.resendStatus === 'standby') {
      this.$emit('resend-requested')
    }
  }
}

export type ResendStatus = 'standby' | 'sending' | 'complete'
